import { isSuccess } from '@/context/services/type';
import { isCommonError } from '@/libs/typeguard/isError';
import {
  ApprovingInvoiceReportBusinessDocumentResponse,
  useGetApprovingInvoiceReportBusinessDocumentSuspense,
} from 'ap-openapi';
import { useMemo } from 'react';

export type UseApprovingInvoiceReportBusinessDocumentResult = {
  data?: ApprovingInvoiceReportBusinessDocumentResponse;
  error?: {
    messages?: string[];
    code?: string;
  };
};

export const useApprovingInvoiceReportBusinessDocumentService = (
  businessDocumentId?: string
): UseApprovingInvoiceReportBusinessDocumentResult => {
  const { data, error } = useGetApprovingInvoiceReportBusinessDocumentSuspense(
    businessDocumentId || '',
    {
      query: {
        queryKey: [
          'approvingInvoiceReportBusinessDocument',
          businessDocumentId,
        ],
      },
    }
  );

  if (error) {
    throw error;
  }

  const body = data?.data;
  const status = data?.status;
  const isSuccessStatus = isSuccess(status);

  return useMemo(() => {
    if (!isSuccessStatus) {
      if (typeof body === 'object' && isCommonError(body)) {
        return {
          data: undefined,
          error: {
            messages: body?.messages,
            code: status?.toString(),
          },
        };
      }
      return {
        data: undefined,
        error: {
          messages: undefined,
          code: status?.toString(),
        },
      };
    }
    return {
      data: body,
      error: undefined,
    };
  }, [body, isSuccessStatus, status]);
};
